import { ADMIN_LOCALE, EMPTY_PLACEHOLDER } from './constants';

export interface CountOptions {
  /** Rendered when the value is not a finite number. */
  fallback?: string;
}

/**
 * Formats a plain count — row totals, item counts, seat counts.
 *
 * NOT MONEY. Nothing here formats an amount, a price or a currency, and no
 * caller may reuse this for one: counts and monetary amounts have different
 * units, different rounding rules and different precision, and the unapproved
 * money representation (DQ-01) must not arrive here as a side effect of
 * "just reusing the number formatter".
 */
export function formatCount(value: number, options: CountOptions = {}): string {
  const { fallback = EMPTY_PLACEHOLDER } = options;
  if (!Number.isFinite(value)) return fallback;

  return new Intl.NumberFormat(ADMIN_LOCALE).format(value);
}
